import supabase from "../helpers/init-supabase";

/**
 *
 * @param {object} participantData - object containing data of the participant
 */
export function createParticipant(participantData) {
  return supabase
    .from('participants')
    .insert([participantData])
    .select()
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      return { data: resp.data[0] };
    })
    .catch(error => ({ error }));
}

/**
 *
 * @param participantEmail - email of the participant
 */
export function getParticipantByEmail(participantEmail) {
  return supabase
    .from('participants')
    .select('*')
    .eq('email', participantEmail)
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      // Return the first participant if found, or undefined if no participants
      return { data: resp.data && resp.data.length > 0 ? resp.data[0] : undefined };
    })
    .catch(error => ({ error }));
}

/**
 *
 * @param {string} participantId - Supabase participant ID
 * @param {object} newParticipantData - new data for participant
 */
export function updateParticipant(participantId, newParticipantData) {
  return supabase
    .from('participants')
    .update(newParticipantData)
    .eq('id', participantId)
    .select()
    .then(resp => {
      if (resp.error) {
        throw resp.error;
      }
      return { data: resp.data[0] };
    })
    .catch(error => ({ error }));
}